// Device-orientation (tilt) input for the cleanse mini-game.
//
// iOS 13+ gates DeviceOrientation behind a permission prompt that must be
// requested from a user gesture — so `enable()` is called from the "Begin"
// tap. On Android/desktop the listener just attaches. If no orientation data
// ever arrives (desktop), `available` stays false and callers fall back to
// pointer input.

export class Tilt {
  available = false;
  beta = 0; // front-back tilt (deg)
  gamma = 0; // left-right tilt (deg)
  private enabled = false;

  async enable(): Promise<void> {
    if (this.enabled) return;
    this.enabled = true;
    const DOE = window.DeviceOrientationEvent as
      | (typeof DeviceOrientationEvent & { requestPermission?: () => Promise<"granted" | "denied"> })
      | undefined;
    if (!DOE) return;
    if (typeof DOE.requestPermission === "function") {
      try {
        const res = await DOE.requestPermission();
        if (res !== "granted") return;
      } catch {
        return; // not in a gesture / denied
      }
    }
    window.addEventListener("deviceorientation", this.onOrient);
  }

  private onOrient = (e: DeviceOrientationEvent) => {
    if (e.gamma == null || e.beta == null) return;
    this.gamma = e.gamma;
    this.beta = e.beta;
    this.available = true;
  };
}
